import AsyncStorage from "@react-native-async-storage/async-storage";
import { useNavigation } from "@react-navigation/core";
import { useRoute } from "@react-navigation/native";
import React, { useEffect, useState } from "react";
import { Text, TouchableOpacity, View } from "react-native";
import balanceService from "../../services/balanceService";
import { formatCoin } from "../../utils/formatNumber";
import HeaderTabs from "../../components/HeaderTabs";
import { styles } from "./styles";
import { FormattedMessage, useIntl } from "react-intl";
import NumberInput from "../../components/NumberInput";

const WithdrawGPX = () => {
  const navigation = useNavigation();
  const route = useRoute();

  const [userName, setUserName] = useState("");
  const [value, setValue] = useState("50");
  const [fee, setFee] = useState(6);
  const [balance, setBalance] = useState("0");
  const [authToken, setAuthToken] = useState("");

  useEffect(() => {
    async function getUserName() {
      const userName = await AsyncStorage.getItem("nameuser");
      setUserName(userName);
    }
    getUserName();
    loadTokenAndRequest();
  }, []);

  useEffect(() => {
    if (authToken && authToken.length > 0) {
      loadBalance();
    }
  }, [authToken]);

  const { bankAccountId } = route.params;

  const loadTokenAndRequest = async () => {
    const authTokenStorage = await AsyncStorage.getItem("JWT_TOKEN");
    setAuthToken(authTokenStorage);
  };

  const loadBalance = () => {
    if (authToken) {
      balanceService
        .getBalanceOfGpx(authToken)
        .then((response) => {
          if (response?.data?.balance?.length > 0) {
            setBalance(response?.data?.balance[0].saldo + "");
          }
        })
        .catch((error) => {});
    }
  };

  const checkValue = () => {
    if (parseInt(value + "") < 50) {
      setValue("50");
    }
  };

  const intl = useIntl();
  const navigateNext = () => {
    if (parseFloat(balance) < parseFloat(value)) {
      alert(intl.formatMessage({ id: "withdrawgpx.saldoInsuficiente" }));
      return;
    }
    navigation.navigate({
      name: "WithdrawGPXPassword",
      params: { value, bankAccountId },
    });
  };

  return (
    <View>
      <HeaderTabs
        title={<FormattedMessage id="withdrawgpx.sacarGpx" />}
        subtitle={<FormattedMessage id="withdrawgpx.confirmeDados" />}
      />

      <View style={styles.container}>
        <View>
          <View style={{ marginBottom: 12 }}>
            <Text style={styles.confirmacaoSaque}>
              <FormattedMessage id="withdrawGpx.confirmacaoSaque" />
            </Text>
          </View>

          <Text>
            <FormattedMessage id="withdrawgpx.digiteQuantidade" />
          </Text>
          <View style={styles.inputContainer}>
            <NumberInput
              value={value}
              onChangeText={setValue}
              keyboardType="number-pad"
              defaultValue="0.1"
              onBlur={() => {
                checkValue();
              }}
            />
            {/* <TextInput
              style={styles.input}
              value={value}
              onChangeText={setValue}
              keyboardType="number-pad"
              defaultValue="0.1"
              onBlur={() => {
                checkValue();
              }}
            /> */}
            <TouchableOpacity>
              <Text style={styles.textBold}>{/*Máx*/}</Text>
            </TouchableOpacity>
          </View>

          <View style={{ alignItems: "center", marginBottom: 12 }}>
            <Text>
              <FormattedMessage id="withdrawgpx.minimoDe" />
            </Text>
          </View>
          <View style={styles.receiver}>
            <Text style={styles.textBold}>
              <FormattedMessage id="withdrawgpx.recebedor" />
            </Text>
            <Text>{userName}</Text>
          </View>
          <View style={styles.hrLine}></View>

          <View style={styles.summary}>
            <View style={styles.spaceBetween}>
              <Text style={styles.label}>
                <FormattedMessage id="withdrawgpx.valorSaque" />
              </Text>
              <Text>
                {formatCoin(parseFloat(value) || 0)}{" "}
                <FormattedMessage id="withdrawgpx.gpx" />
              </Text>
            </View>
            <View style={styles.hrLine}></View>

            <View style={styles.spaceBetween}>
              <Text style={styles.label}>
                <FormattedMessage id="withdrawgpx.taxaGpx" />
              </Text>
              <Text>
                {formatCoin(fee)} <FormattedMessage id="withdrawgpx.gpx" />
              </Text>
            </View>

            <View style={styles.hrLine}></View>

            <View style={styles.spaceBetween}>
              <Text style={styles.label}>
                <FormattedMessage id="withdrawgpx.valorReceber" />
              </Text>
              <Text>
                {formatCoin((parseFloat(value) || 0) - fee)}{" "}
                <FormattedMessage id="withdrawgpx.gpx" />
              </Text>
            </View>

            <View style={styles.hrLine}></View>
          </View>
        </View>

        <View style={{ alignSelf: "center" }}>
          <TouchableOpacity
            style={styles.btnConfimeSaque}
            onPress={() => {
              navigateNext();
            }}
          >
            <FormattedMessage id="withdrawgpx.confirmar" />
          </TouchableOpacity>
        </View>
      </View>
    </View>
  );
};

export default WithdrawGPX;
